import {TranslatedWord} from './FieldConfiguration';
import {FieldId, SectionId} from './types';

export interface Field {
  id: FieldId
  type: FieldType
  sectionId: SectionId
  label: string
  labels: TranslatedWord[]

  /**
   * Returns true if it's possible to convert the field to the new type
   */
  canConvertTo(newType: FieldType): boolean
}

export enum FieldType {
  Text = 'str',
  TextArea = 'text',
  Checkbox = 'chk',
  Dropdown = 'sel',
  Rating = 'rating',
  StarRating = 'star',
  PercentRating = 'percent',
}
